import React from "react";
var __jsx = React.createElement;
function OfferIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "94",
    height: "94",
    viewBox: "0 0 94 94",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group Copy"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: "47",
    cy: "47",
    r: "47",
    fill: "#00B362"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "18.1592",
    y: "24.5682",
    width: "58.75",
    height: "69.4318",
    rx: "5.2",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M55.4951 35.4018L44.3287 46.6161L39.3512 41.6324C38.4435 40.7234 36.9691 40.721 36.0581 41.6264C35.147 42.532 35.1444 44.003 36.0521 44.9118L41.9548 50.822C42.5884 51.457 43.4319 51.8068 44.33 51.8068H44.3321C45.2307 51.8062 46.0745 51.4555 46.7077 50.8196L58.799 38.6763C59.7054 37.7662 59.7005 36.2951 58.7882 35.3909C57.8757 34.4867 56.4014 34.4914 55.4951 35.4018Z",
    fill: "#00B362"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: "32.0459",
    y: "59.8182",
    width: "30.9773",
    height: "3.20455",
    fill: "#DAE5F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 4",
    x: "32.0459",
    y: "74.7727",
    width: "30.9773",
    height: "3.20455",
    fill: "#DAE5F4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 3",
    x: "26.7041",
    y: "67.2954",
    width: "41.6591",
    height: "3.20455",
    fill: "#DAE5F4"
  })));
}
export default OfferIcon;